// src/hooks/useOlsmeTimer.ts
import { useTimer } from "../context/TimerContext";

// Type Definitions
interface OlsmeTimerData {
  timer: string;
  sessionLabel: string;
  nextSession: string;
  isSessionActive: boolean;
}

const useOlsmeTimer = (): OlsmeTimerData => {
  return useTimer();
};

export default useOlsmeTimer;